import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// El gestor de la sesión. Es el del admin con otro client: por qué
// oidc-client-ts y no keycloak-js, por qué sessionStorage, por qué la
// renovación silenciosa y por qué sin monitorSession está explicado en
// `apps/admin/src/sesion/gestor.ts`, y las razones son las mismas.
//
// **Lo único que cambia es el client**, y no es un detalle: `tallerya-plataforma`
// tiene su propio flujo de ingreso en Keycloak, que le niega la entrada a quien
// no tenga el rol `platform-admin`. Apuntar esto a `tallerya-admin` dejaría
// entrar a cualquiera del realm.
const url = import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080';
const realm = import.meta.env.VITE_KEYCLOAK_REALM ?? 'tallerya';
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'tallerya-plataforma';

export const autoridad = `${url.replace(/\/$/, '')}/realms/${realm}`;

export const gestorSesion = new UserManager({
  authority: autoridad,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',

  // Acá sessionStorage pesa más que en el admin: esta sesión ve a todos los
  // talleres. Cerrar la pestaña tiene que cerrarla.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),

  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  monitorSession: false,
});
